import React from 'react'
// import MainButton from '../btns/MainButton'
// import PurpleBtn from '../btns/PurpleBtn'
// import FilmCard from '../cards/FilmCard'
// import jokerPoster from '../../assets/img/jokerPoster.webp';
import SuIdmanSarayiToday from './SuIdmanSarayiToday';
// import BuzovnaToday from './BuzovnaToday';
// import { useTranslation } from 'react-i18next';


const CenterFilms = () => {
  // const { t } = useTranslation();
  
  return (
    <div className='container grid grid-cols-1 gap-6'>
    <div>
        <p className='p-[10px_15px] rounded-[12px] font-semibold w-full bg-main text-white border border-purple text-center mb-5'>Buzovna Dənizkənarı</p>
            <SuIdmanSarayiToday/>

    </div>
    {/* Buzovna Parking — временно скрыт, код сохранён для возможного возврата
    <div>
        <p className='p-[10px_15px] rounded-[12px] font-semibold w-full bg-main text-white border border-blue text-center mb-5'>Buzovna Parking</p>
            <BuzovnaToday/>
    </div>
    */}
    </div>
  )
}

export default CenterFilms